export enum PostNewReceivableInvoiceStatus {
    InActive = 0,
    Issue = 1,
    Claim = 2,
    Settlement = 3,
    Manual = 4
}